import React from 'react'

import ExamSubmitButton from '@components/Button/ExamSubmitButton/ExamSubmitButton'

export type ExamSubmitButtonContainerProps = {
  viewResultMode: boolean
  setShowSubmitModal: (trueFalse: boolean) => void
  isDelivery?: boolean
}

const ExamSubmitButtonContainer: React.FC<ExamSubmitButtonContainerProps> = ({
  viewResultMode,
  setShowSubmitModal,
  isDelivery,
}) => {
  const handleSubmitQuestionInformation = () => {
    setShowSubmitModal(true)
  }

  const props = {
    viewResultMode,
    handleSubmitQuestionInformation,
    isDelivery,
  }

  return <ExamSubmitButton {...props} />
}

export default ExamSubmitButtonContainer
